import { Injectable, inject } from '@angular/core';

import { Observable } from 'rxjs';

import { InitializationResult, UserInitialization } from '@core/models/user-initialization.interface';

import { PatientDashboardApiService } from './patient-dashboard-api.service';

@Injectable({
  providedIn: 'root',
})
export class PatientInitializationService implements UserInitialization {
  private readonly patientDashboardService = inject(PatientDashboardApiService);

  public initialize(): Observable<InitializationResult> {
    return this.patientDashboardService.getPatientDashboardData();
  }
}
